var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNoitemfound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "m6dobz2wea",
    d: "M0 0h31.305v36H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o769kse9sb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m6dobz2wea"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.203 18.75a1.531 1.531 0 0 0-1.531 1.54c.009.85.695 1.518 1.558 1.516.851-.002 1.546-.7 1.53-1.54a1.533 1.533 0 0 0-1.557-1.515m.048-6.663a1.556 1.556 0 0 0-1.579 1.502c-.026.842.688 1.572 1.545 1.578.813.007 1.524-.687 1.544-1.507a1.559 1.559 0 0 0-1.51-1.573m9.17 9.72c1.345 0 2.69.006 4.036-.002.691-.004 1.23-.39 1.453-1.01.38-1.053-.38-2.069-1.576-2.073-2.597-.01-5.194-.004-7.791-.002-.21 0-.42.02-.622.09-.688.237-1.143.954-1.042 1.644.114.784.718 1.342 1.505 1.35 1.346.012 2.691.003 4.037.004m3.074-9.722c-2.318 0-4.637 0-6.955.002-.152 0-.307-.003-.454.028-.827.178-1.317.882-1.222 1.742.084.77.76 1.325 1.64 1.325 4.66.003 9.32.003 13.98 0 .963 0 1.684-.686 1.67-1.57-.014-.883-.714-1.526-1.668-1.526h-6.99M11.978 0h7.308c.092.016.182.045.274.047 1.533.038 3.063.124 4.593.235 1.273.092 2.465.428 3.531 1.133 2.177 1.44 3.219 3.506 3.33 6.086.115 2.68.192 5.36.222 8.042.01.911-.028 1.825.068 2.734v2.601c-.015.186-.04.37-.042.556-.034 3.385-.08 6.77-.245 10.15-.052 1.059-.202 2.093-.64 3.072-.574 1.286-1.729 1.684-2.974 1.015a962.797 962.797 0 0 1-4.104-2.217c-.721-.392-1.422-.374-2.133.033-1.136.65-2.282 1.285-3.424 1.924-1.415.79-2.828.784-4.24-.01-1.12-.632-2.248-1.25-3.362-1.893-.76-.439-1.49-.437-2.258-.011-1.37.76-2.75 1.498-4.135 2.232-1.098.582-2.262.181-2.795-.936C.47 33.781.3 32.703.248 31.597c-.133-2.82-.195-5.641-.225-8.464-.057-5.435-.026-10.868.289-16.296.155-2.682 2.103-5.212 4.71-6.135C6.382.22 7.807.259 9.213.142 10.133.067 11.061.124 11.98 0",
    fillOpacity: 0.148,
    fill: "#FFF",
    mask: "url(#o769kse9sb)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoitemfound);
export default __webpack_public_path__ + "static/media/ic_noitemfound.cdaeebf0068ac4ac90aacc1d33d37f6f.svg";
export { ForwardRef as ReactComponent };